import { ManualTaskDefinition } from 'Automations/nodeDefinitions/types'
import { CustomerInfoReviewContent } from './components/reviewContent/CustomerInfoReviewContent'
import { CustomerInfoReviewListItemContent } from './components/listItemContent/CustomerInfoReviewListItemContent'

/**
 * Manual task definition for the customer-queries agent's proposed customer
 * info changes. Registered under `CUSTOMER_INFO_REVIEW` in `manualReviewTasks`
 * so it renders in the inbox list (`listItemContent`) and opens the full-screen
 * processor (`reviewContent`). The details/logs preview pane is rendered by
 * `ManualTaskPreview` via `CustomerInfoReviewPreview`.
 */
export const customerInfoReviewManualTask: ManualTaskDefinition = {
  reviewContent: CustomerInfoReviewContent,
  listItemContent: CustomerInfoReviewListItemContent
}
